import { useCallback, useState } from "react"
import { Heading } from "@chakra-ui/react"

import ModalLeave from "#/ui-old/Modal/ModalLeave"

import DepositModalButton from "./DepositModalButton"
import DepositModalLongWaitTime from "./DepositModalLongWaitTime"
import DepositModalReceiptDetails from "./DepositModalReceiptDetails"

const TRANSACTION_TIME_CAP = 10_000 // 10 seconds

export default function DepositModalReceipFromCurrentWallet({
  close,
  showClosingModal,
  setConfirmModalClose,
}: {
  close: () => void
  showClosingModal: boolean
  setConfirmModalClose: (value: boolean) => void
}) {
  const [isTransactionTakingLongTime, setIsTransactionTakingLongTime] =
    useState(false)

  const depositButtonClickHandler = useCallback(() => {
    const timeout = setTimeout(() => {
      setIsTransactionTakingLongTime(true)
    }, TRANSACTION_TIME_CAP)

    return () => clearTimeout(timeout)
  }, [])

  if (showClosingModal) {
    return (
      <ModalLeave
        header="Leave deposit?"
        stayText="Stay, I'm depositing"
        leaveModalText="Leave, not depositing"
        onClose={close}
        backToProcessTrigger={() => setConfirmModalClose(false)}
      />
    )
  }

  return (
    <>
      <Heading variant="h3" textAlign="center" mb={8}>
        Finalise deposit
      </Heading>
      <DepositModalReceiptDetails />
      <DepositModalButton onClick={depositButtonClickHandler} />
      <DepositModalLongWaitTime
        isTransactionTakingLongTime={isTransactionTakingLongTime}
      />
    </>
  )
}
